import { enableProdMode } from '@angular/core';
import { Acl } from '@df/core/service/acl';
import { fastBootstrapApplication } from 'ngx-fastboot';

if (Acl.isProdMode()) {
    enableProdMode();
}

fastBootstrapApplication(() => import(/* webpackChunkName: "app" */ './app/app.component').then(m => m.AppComponent), {
    providers: [() => import(/* webpackChunkName: "app-config" */ './app/app.config').then(m => m.appConfig.providers)]
}).catch(error => {
    console.error(error);
});
